module.exports = __webpack_public_path__ + "img/BAU Seniors_22.6ec307ce.jpg";